import script from "./TriadTunerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TriadTunerModal.vue?vue&type=script&setup=true&lang=js"

import "./TriadTunerModal.vue?vue&type=style&index=0&id=3b8b9c2f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b8b9c2f"]])

export default __exports__